import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import { ValidatorForm } from 'react-material-ui-form-validator';
import { Input, Button, H2, SuccessBlock } from 'components/Ui';
import { arrowBackward } from 'images';
import { connect } from 'react-redux';
import { addAuthorizedUser as addAuthorizedUserAction } from 'containers/PrimoProfile/actions';
import { createStructuredSelector } from 'reselect';
import { selectAddAuthorizedUserSuccessful } from '../selectors';
import styles from './styles.scss';
import commonStyles from '../styles.scss';

const AddNewAccountLoginForm = ({
  onClose,
  isAddAuthorizedUserSuccessful,
  addAuthorizedUser,
}) => {
  const [values, changeValues] = useState({});

  const handleChange = ({ target: { value, name } }) => {
    changeValues({ ...values, [name]: value });
  };

  const handleSubmit = () => {
    addAuthorizedUser(values);
  };

  return (
    <>
      {!isAddAuthorizedUserSuccessful ? (
        <ValidatorForm onSubmit={handleSubmit}>
          <Button
            className={styles.backButton}
            text="Back"
            icon={<img src={arrowBackward} alt="backward" />}
            onClick={onClose}
            iconPosition="left"
            link
          />
          <H2 className={commonStyles.header}>
            Create account login credentials for an additional user
          </H2>
          <div className={styles.inputFields}>
            <Input
              label="First Name:"
              name="firstName"
              id="firstName"
              ariaLabel="First Name"
              smallLabel
              value={values.firstName}
              onChange={handleChange}
            />
            <Input
              label="Last Name:"
              name="lastName"
              id="lastName"
              ariaLabel="Last Name"
              smallLabel
              value={values.lastName}
              onChange={handleChange}
            />
            <Input
              label="Email Address:"
              name="emailAddress"
              id="emailAddress"
              ariaLabel="Email address"
              smallLabel
              value={values.email}
              onChange={handleChange}
            />
          </div>
          <Fragment>
            <div className={styles.formBottom}>
              <Button
                className={commonStyles.cancelButton}
                text="Cancel"
                type="button"
                onClick={onClose}
              />
              <Button
                className={commonStyles.button}
                text="Save"
                type="button"
                onClick={handleSubmit}
              />
            </div>
          </Fragment>
        </ValidatorForm>
      ) : (
        <div className={styles.successContainer}>
          <SuccessBlock text="Your changes have been saved." />
        </div>
      )}
    </>
  );
};
AddNewAccountLoginForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  isAddAuthorizedUserSuccessful: PropTypes.bool,
  addAuthorizedUser: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  isAddAuthorizedUserSuccessful: selectAddAuthorizedUserSuccessful(),
});

const mapDispatchToProps = {
  addAuthorizedUser: addAuthorizedUserAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddNewAccountLoginForm);
